import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import { CoreStoreModule, CoreStoreState } from '@/core';
import { DashBoardStoreModule, DashBoardStoreState } from '@/modules/msw-dashboard';
import { RenewalManagerStoreModule, RenewalManagerStoreState } from '@/modules/msw-renewal-manager';
import { MswProductsStoreModule, ProductsStoreState } from '@/modules/msw-products';
import { MswUserGroupStoreModule, UserGroupStoreState } from '@/modules/msw-products/components/msw-user-group/store';
import { DropdownStoreState, DropdownStoreModule } from '@/shared/dropdown-three-component';
import { FlexspendStoreState, FlexspendStoreModule } from '@/modules/msw-flexspend';
import {
  DattoAutotaskStoreModule,
  DattoAutotaskStoreState,
  ConnectWiseManageStoreModule,
  ConnectWiseManageStoreState,
  PsaHubStoreModule,
  PsaHubStoreState,
} from '@/modules/psa-integration-connectwise';
import { SpogHomepageStoreModule, SpogHomePageStoreState } from '@/modules/msw-spog-homepage';
import { UnifiedInsightsStoreModule, UnifiedInsightsStoreState } from '@/modules/unified-insights';
import { DownloadCenterStoreModule, DownloadCenterStoreState } from '@/modules/download-center';
import { ActivityLogsStoreModule, ActivityLogsStoreState } from '@/modules/msw-activitylogs';
import { UnifiedInsightsReportsStoreModule, UnifiedInsightsReportsStoreState } from '@/modules/unified-insights/unified-insights-reports';
import { SwQsgStoreStateModule, SwQsgStoreState } from '@/core/sw-qsg';
import { TenantManagementStoreModule, TenantManagementStoreState } from '@/modules/msw-tenant-management';
import { AtpTrainingStoreModule, AtpTrainingStoreState } from '@/modules/msw-atp-training';
import { AccessManagementStoreModule, AccessManagementStoreState } from '@/modules/msw-accessmgmt';
import { MswIssueListModule, MswIssueListState } from '@/modules/msw-issue-list';
import { MswLookupToolModule, MswLookupToolState } from '@/modules/msw-lookup-tool';
import { MswAlertModule, MswAlertsState } from '@/modules/msw-alert-slider';
import { MswSupportCasesModule, MswSupportCasesState } from '@/modules/msw-support-cases';
import { SubscriptionReportStoreModule, SubscriptionReportState } from '@/modules/msw-myreports';
import { CatpProtectionStoreModule, CatpProtectionStoreState } from '@/modules/catp-protection';
import { MswPartnerResourcesModule, MswPartnerResourcesState } from '@/modules/msw-partner-resources';
import { NotificationCenterStoreModule, NotificationCenterStoreState } from '@/modules/msw-notification-center';
import { SnbQuotesStoreModule, SnbQuotesStoreState } from '@/modules/msw-quotecomponent';
import { CatalogStoreModule, CatalogStoreState } from '@/modules/msw-catalog';
import { CheckoutStoreModule, CheckoutStoreState } from '@/modules/msw-checkout';
import { MswProductClaimsModule, MswProductClaimsState } from '@/modules/msw-product-claims';
import { AvailableServicesStoreModule, AvailableServicesStoreState } from '@/modules/msw-available-services';
import { DownloadSignatureStoreModule, DownloadSignatureStoreState } from '@/modules/msw-download-signature';
import { SandboxAutoRenewalState, SandboxAutoRenewalStoreModule } from '@/modules/msw-auto-renewals';
import { SnbCoTermStoreModule, SnbCoTermStoreState } from '@/modules/msw-service-coterm';
import { NfrServiceStoreStateModule, NfrServiceStoreState } from '@/modules/msw-nfr-service';
import { SnbProfileStoreModule, SnbProfileStoreState } from '@/modules/msw-profile';
import { FreeDownloadsStoreModule, FreeDownloadsStoreState } from '@/modules/free-downloads';
import { TrainingStoreModule, TrainingStoreState } from '@/modules/msw-training';
import { BetaProgramStoreModule, BetaProgramStoreState } from '@/modules/msw-beta-program';
import { MswFreSoftwareTrailModule, MswFreeSoftwareTrialState } from '@/modules/msw-free-software-trials';

export interface RootStoreState {
  CoreStoreModule: CoreStoreState;
  DashboardStore: DashBoardStoreState;
  MswRenewalManagerStore: RenewalManagerStoreState;
  SpogHomePageStoreState : SpogHomePageStoreState;
  MswProductsStoreModule: ProductsStoreState;
  UnifiedInsightsStoreState : UnifiedInsightsStoreState;
  UnifiedInsightsReportsStoreState : UnifiedInsightsReportsStoreState;
  DownloadCenterStoreState : DownloadCenterStoreState;
  ActivityLogsStoreState: ActivityLogsStoreState;
  DropdownStoreModule: DropdownStoreState;
  MswUserGroupStoreModule: UserGroupStoreState;
  FlexspendStoreModule: FlexspendStoreState;
  SwQsgStoreStateModule: SwQsgStoreState;
  TenantManagementStoreModule: TenantManagementStoreState;
  AtpTrainingStoreState: AtpTrainingStoreState;
  AccessManagementStoreModule: AccessManagementStoreState;
  MswIssueListModule: MswIssueListState;
  MswLookupToolModule: MswLookupToolState;
  MswSupportCasesModule: MswSupportCasesState;
  MswAlertModule: MswAlertsState;
  CatpProtectionStoreModule: CatpProtectionStoreState;
  SubscriptionReportStoreModule : SubscriptionReportState;
  MswPartnerResourcesModule: MswPartnerResourcesState;
  NotificationCenterStoreModule: NotificationCenterStoreState;
  SnbQuotesStoreModule: SnbQuotesStoreState;
  CatalogStoreModule: CatalogStoreState;
  CheckoutStoreModule: CheckoutStoreState;
  MswProductClaimsModule: MswProductClaimsState;
  AvailableServicesStoreModule: AvailableServicesStoreState;
  DownloadSignatureStoreModule: DownloadSignatureStoreState;
  SandboxAutoRenewalState: SandboxAutoRenewalState;
  SnbCoTermStoreModule: SnbCoTermStoreState;
  NfrServiceStoreState: NfrServiceStoreState;
  SnbProfileStoreModule: SnbProfileStoreState;
  FreeDownloadsStoreModule: FreeDownloadsStoreState;
  TrainingStoreModule: TrainingStoreState;
  BetaProgramStoreModule: BetaProgramStoreState;
  DattoAutotaskStoreModule: DattoAutotaskStoreState;
  MswFreSoftwareTrailModule: MswFreeSoftwareTrialState;
  ConnectWiseManageStoreModule: ConnectWiseManageStoreState;
  PsaHubStoreModule: PsaHubStoreState;
  [module: string]: any;
}
Vue.use(Vuex);

const store = new Vuex.Store<RootStoreState>({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    CoreStoreModule,
    DashBoardStoreModule,
    RenewalManagerStoreModule,
    UnifiedInsightsStoreModule,
    UnifiedInsightsReportsStoreModule,
    DownloadCenterStoreModule,
    ActivityLogsStoreModule,
    SpogHomepageStoreModule,
    MswProductsStoreModule,
    MswUserGroupStoreModule,
    DropdownStoreModule,
    FlexspendStoreModule,
    SwQsgStoreStateModule,
    TenantManagementStoreModule,
    AtpTrainingStoreModule,
    AccessManagementStoreModule,
    MswIssueListModule,
    MswLookupToolModule,
    MswSupportCasesModule,
    MswAlertModule,
    SubscriptionReportStoreModule,
    CatpProtectionStoreModule,
    MswPartnerResourcesModule,
    NotificationCenterStoreModule,
    SnbQuotesStoreModule,
    CatalogStoreModule,
    CheckoutStoreModule,
    MswProductClaimsModule,
    AvailableServicesStoreModule,
    DownloadSignatureStoreModule,
    SandboxAutoRenewalStoreModule,
    SnbCoTermStoreModule,
    NfrServiceStoreStateModule,
    SnbProfileStoreModule,
    FreeDownloadsStoreModule,
    TrainingStoreModule,
    BetaProgramStoreModule,
    DattoAutotaskStoreModule,
    MswFreSoftwareTrailModule,
    ConnectWiseManageStoreModule,
    PsaHubStoreModule,
  },
});

export default store;

export type AppStore = Store<RootStoreState>;
